import { useCallback } from 'react'

import { useRouter, useSearchParams } from 'next/navigation'

import { INTERACTIFY_PARAM_KEY } from '../constants'

export const useInteractifyParams = () => {
    const router = useRouter()
    const searchParams = useSearchParams()

    const activeInteractifyParam = searchParams.get(INTERACTIFY_PARAM_KEY) || undefined

    const removeInteractifyParam = useCallback(() => {
        const params = new URLSearchParams(searchParams.toString())

        params.delete(INTERACTIFY_PARAM_KEY)

        router.replace('?' + params.toString(), { scroll: false })
    }, [router, searchParams])

    const addInteractifyParam = useCallback(
        (slug: string, isPushingNewRoute = false) => {
            const params = new URLSearchParams(searchParams.toString())

            params.set(INTERACTIFY_PARAM_KEY, slug)

            const url = '?' + params.toString()

            if (isPushingNewRoute) router.push(url, { scroll: false })
            else router.replace(url, { scroll: false })
        },
        [router, searchParams]
    )

    return {
        activeInteractifyParam,
        removeInteractifyParam,
        addInteractifyParam,
    }
}
